<template>
	<div />
</template>

<script>
import { mapGetters } from 'vuex'
import { initializeDibsEasy } from '@/api/modules/confirm'

export default {
	data() {
		return {
			paymentId: null,
			hostedPaymentPageUrl: null,
		}
	},
	computed: {
		returnUrl() {
			return window.location.origin + '/payment/' + `?provider=DibsEasy&reference=${encodeURIComponent(this.orderId)}`
		},
		...mapGetters({
			orderId: 'order/getOrderId',
		}),
	},
	watch: {
		hostedPaymentPageUrl: function (value) {
			if (value) {
				window.location.href = value
			}
		},
	},
	mounted() {
		this.$emit('loading', 'Redirecting to DIBS')
		return initializeDibsEasy(this.orderId, this.returnUrl).then((response) => {
			if (!response.ok) {
				throw new Error(JSON.stringify(response))
			}

			this.paymentId = response.responseBody.paymentId
			this.hostedPaymentPageUrl = response.responseBody.hostedPaymentPageUrl + '&language=en-GB'
		})
	},
}
</script>
